export const ContractCodeStatus = {
    BOOK: 'ContractingDecisions:Booked',
    CANC: 'Contracting:Cancelled',
    CFAIL: 'Contracting:SaveFailed',
    CSAV: 'Contracting:SavedSuccessfully',
    FUND: 'ContractingDecisions:Funded',
    PDOC: 'ContractingDecisions:PendingDocs',
    PSIGN: 'Contracting:PartiallySigned',
    RTRN: 'ContractingDecisions:Returned',
    SAVE: 'Contracting:SavedSuccessfully',
    SIGN: 'Contracting:Signed',
    SUBF: 'Contracting:SubmittedForFunding',
    SUBS: 'Contracting:DocumentsSubmittedForSigning',
    VEXP: 'ContractingDecisions:VerificationExpired',
    VPEN: 'Contracting:SubmittedForVerification',
    VRFA: 'ContractingDecisions:VerificationFailed',
    VRFY: 'ContractingDecisions:Verified',
    VRWR: 'ContractingDecisions:VerifiedWithWarnings'
} as const;
